const type = 'advanced'
const path = '/advance/3ds-node/public/'
const name = 'app.js'

const conditions = [
  {
    parameter: 'buttons',
    type: 'includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, conditions }
